import React from "react";

const sumPurchase = (obj, calculateBy) => {
    let grandTotal = 0;
    calculateBy.forEach((key) => {
        if (obj[key]) {
            Object.keys(obj[key]).forEach((slug) => {
                const equipment = obj[key][slug];
                grandTotal = obj[key][slug].reduce((total, item) => {
                    return (total += parseFloat(item[`${key}_default`]));
                }, grandTotal);
            });
        }
    });
    return grandTotal;
};

function TotalDue(props) {
    const { title, calculateBy, equipments, otherDue = 0 } = props;
    if (Object.keys(equipments).length == 0) return null;
    const totalPrice = sumPurchase(equipments, calculateBy) + otherDue;
    return (
        <div className="cost-item">
            <span className="text">{title}</span>
            <span className="dots"></span>
            <span className="amount highlighted">
                $ {totalPrice?.toFixed(2)}
            </span>
        </div>
    );
}

export default TotalDue;
